import api from './api';

const submitModal = (payload: any) => {
  if (payload?.type === 'pdpConsentNotLoggedIn') {
    return api.put(
      '/api/submit-modal',
      null,
      { ...payload },
      {
        baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
      }
    );
  } else {
    return api.post(
      '/api/submit-modal',
      null,
      { ...payload },
      {
        baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
      }
    );
  }
};

export default { submitModal };
